export default __webpack_public_path__ + "static/media/PFBVisionPlan_ScheduleOfBenefits.4a4fdbd5.pdf";